import React from 'react';
import classNames from 'classnames';

import { useConfiguration } from '../../context/configurationContext';
import { useLanguage } from '../../context/languageContext';
import { useIntl } from '../../util/reactIntl';

import css from './LanguageSwitcher.module.css';

const LanguageSwitcher = props => {
  const { className, rootClassName } = props;
  const config = useConfiguration();
  const { changeLanguage } = useLanguage();
  const intl = useIntl();
  const { language, availableLanguages = [] } = config.localization;
  const classes = classNames(rootClassName || css.root, className, {
    [css.finnishActive]: language === 'fi',
  });
  const label = intl.formatMessage({ id: 'LanguageSwitcher.label' });

  return (
    <div className={classes} role="group" aria-label={label}>
      <span className={css.label}>{label}</span>
      <span className={css.activeIndicator} aria-hidden="true" />
      {availableLanguages.map(option => {
        const isActive = option.language === language;
        return (
          <button
            key={option.language}
            className={classNames(css.option, { [css.activeOption]: isActive })}
            type="button"
            aria-pressed={isActive}
            onClick={() => (isActive ? null : changeLanguage(option.language))}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
